import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.06752 1.1841C1.82353 0.939934 1.42795 0.939934 1.18397 1.1841C0.93998 1.42827 0.93998 1.82415 1.18397 2.06832L7.11648 8.00525L1.19028 13.9359C0.946297 14.18 0.946297 14.5759 1.19028 14.8201C1.43427 15.0642 1.82985 15.0642 2.07384 14.8201L8.00004 8.88946L13.9262 14.8201C14.1702 15.0642 14.5658 15.0642 14.8098 14.8201C15.0538 14.5759 15.0538 14.18 14.8098 13.9359L8.88359 8.00525L14.8161 2.06832C15.0601 1.82415 15.0601 1.42827 14.8161 1.1841C14.5721 0.939934 14.1765 0.939934 13.9326 1.1841L8.00004 7.12104L2.06752 1.1841Z",
		fill: "currentColor"
	})
});
export default SvgFullCross;
